export default "__VITE_ASSET__DwtfUkTJ__"